// Kontrak host MapService. Dulu 17 nama telanjang di this.vm tanpa deklarasi
// di mana pun; sekarang satu bentuk tetap dengan default aman.
const noop = () => {};
const asyncNoop = () => Promise.resolve();

export function normalizeHost(vm) {
  const host = vm || {};
  const call = (name, fallback) => (...args) => (
    typeof host[name] === 'function' ? host[name](...args) : fallback(...args)
  );

  return {
    get ships() { return host.ships || []; },
    get options() { return host.Options || {}; },
    get mapMode() { return host.mapMode || 'standard'; },
    get hideSettingsControl() { return Boolean(host.hideSettingsControl); },
    get store() { return host.$store || null; },

    onPolylineStart: call('handlePolylineStart', noop),
    onPolylineChange: call('handlePolylineChange', noop),
    onPolylineClear: call('handlePolylineClear', noop),
    onPolylineFinish: call('handlePolylineFinish', noop),

    fetchShipTrail: call('handleFetchShipTrail', asyncNoop),
    fetchTrailPointDetail: call('handleFetchTrailPointDetail', asyncNoop),
    getLastData: call('handleGetLastData', asyncNoop),
    fetchShipSummary: call('handleFetchShipSummary', asyncNoop),

    clickReport: call('handleClickReport', noop),
    clickDashboard: call('handleClickDashboard', noop),
    clickVoyage: call('handleClickVoyage', noop),
    setActiveTrail: call('setActiveTrail', noop),
  };
}

export default normalizeHost;
